import * as React from "react";
import { 
  Col,
  InputGroup,
} from "react-bootstrap";
import * as S from "./styles";

export const MailchimpSubscribeForm: React.FC = ({}) => {
  //FIXME: check console in the browser (maybe handleChange required using formik)
  return (
    <Col>
      <link href="//cdn-images.mailchimp.com/embedcode/horizontal-slim-10_7.css" rel="stylesheet" type="text/css" />
      <S.Wrapper id="mc_embed_signup">
        <form action="https://maccaron.us20.list-manage.com/subscribe/post?u=27fcb2d92726f3f8727ef70af&amp;id=2819583135" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank">
          <InputGroup>
            <label>Sign-Up for special discounts, skincare tips and a first look at the new in’s</label>
            <S.Input type="email" className="form-control" name="EMAIL" id="mce-EMAIL" placeholder="email address" required />
            {/* real people should not fill this in and expect good things - do not remove this or risk form bot signups */}
            <S.Hidden aria-hidden="true">
              <input type="text" name="b_27fcb2d92726f3f8727ef70af_2819583135"/>
            </S.Hidden>
            <InputGroup.Prepend>
              <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="btn btn-primary"/>
            </InputGroup.Prepend>
          </InputGroup>
        </form>
      </S.Wrapper>
    </Col>
  );
}